var $ = require('jquery');

$(function () {
    $('button.updatepassword-form__body__submit').on('click', function (e) {
        formNode.submit();
    });

    $('form').keyup(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $(this).find("button.updatepassword-form__body__submit").click();
        }
    });
});